import { commonJsFuncModule as commonJsObj } from '../utils/commonFunc';

const AuthGuard = () => {
    return commonJsObj.getUserInfo() ? true : false;
}



export { AuthGuard };